/**
 * The words on the templates screens (docs/ux/templates.md): tiers, kinds,
 * sources and origins as Beam says them, the version sentences, and the
 * key a new section gets from its title.
 */

import type { OverlaySource, SectionTier, TemplateHead, TemplateSectionKind } from '@/app/types';

export const TIER_WORD: Record<SectionTier, string> = { core: 'core', optional: 'optional', doctor_specific: 'doctor-specific' };
export const KIND_WORD: Record<TemplateSectionKind, string> = { fields: 'fields', prose: 'prose', list: 'list', questions: 'questions', boilerplate: 'standing text', group: 'heading' };
export const SOURCE_WORD: Record<OverlaySource, string> = { mined: 'mined', confirmed: 'confirmed', authored: 'authored', cloned: 'cloned' };
export const ORIGIN_WORD: Record<'base' | 'specialty' | 'doctor', string> = { base: 'base', specialty: 'specialty', doctor: 'doctor' };
export const METADATA_SOURCE_WORD: Record<'loi' | 'booking' | 'doctor' | 'registry', string> = { loi: 'the letter', booking: 'the booking', doctor: 'the doctor', registry: 'the registry' };

export function versionSentence(head: TemplateHead): string {
  return `Version ${head.liveVersion} of ${head.versions} is live`;
}

export function overlaySentence(overlay: { version: number; source: OverlaySource } | null, baseVersion: number): string {
  if (!overlay) return `Uses the base (version ${baseVersion}).`;
  return `Overlay version ${overlay.version} (${SOURCE_WORD[overlay.source]}) on base version ${baseVersion}.`;
}

/** A section key from a typed title: lower case, letters and digits, underscores. */
export function keyFromTitle(title: string): string {
  return title.trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').replace(/^[0-9]+/, '').slice(0, 40);
}

export function differenceWords(counts: { added: number; removed: number; renamed: number }): string {
  const parts = [`${counts.removed} left out`, `${counts.added} added`, `${counts.renamed} renamed`];
  return parts.join(', ');
}
